module.exports = __webpack_public_path__ + "img/benzinpreis-map-desktop.4d08d02.png";